<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title" v-if="product">{{product.Title}}</div>
      <div class="view-title" v-else>{{ 'product' | lang }}</div>
      <button @click="goTo('/cart', null, true)" :aria-label="dictValue('CartWithItems', {nitems: cartLength})">
        <i class="fa fa-fw fa-shopping-cart" :badge="cartLengthLabel"></i>
      </button>
    </header>
    <div v-if="product">
      <!-- <p>{{ 'price' | lang }}: {{ (product.Amount / 100) | currency }}</p> -->
      <p>{{product.description || 'Spazio per descrizione titolo fornito dal vad' || dictValue ('NoDescription')}}</p>
      <!-- <div class="form-row">
        <label>Quantità</label>
        <count-selector v-model="test" :min="0" />
      </div>
      <advanced-select v-model="testp" label="Partenza" :options="testoptions"/>
      <advanced-select v-model="testa" label="Arrivo" :options="testoptions"/>
      <advanced-select v-model="test" label="Custom input" />
      <button @click="testSteps">Test steps</button> -->
    </div>
    <div class="flexcentered bigger" v-else>{{ 'loading' | lang }}</div>
    <footer>
      <button @click="startBuying">{{ 'BuyButton' | lang }}</button>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
import saleableServices from '@/mixins/services/saleableServices'
// import CountSelector from '@/components/CountSelector'
// import AdvancedSelect from '@/components/AdvancedSelect'

export default {
  name: 'NewProduct',
  mixins: [ page, databaseWrapperMixin, saleableServices ],
  // components: { CountSelector, AdvancedSelect },
  props: ['type', 'productId', 'articleId'],
  data () {
    return {
      product: null
    }
  },
  computed: {
    isCSCproduct () {
      return this.type === 'csc'
    },
    isEticket () {
      return this.type === 'eticket'
    },
    isCSC () {
      return this.type === 'newcsc'
    },
  },
  methods: {
    startBuying () {
      let lst = []
      if (this.product.ApisToCall.indexOf('origins') > -1) {
        lst.push('origins')
      }
      if (this.product.ApisToCall.indexOf('travels') > -1) {
        lst.push('travels')
      }
      if (this.product.ApisToCall.indexOf('via') > -1) {
        lst.push('t')
      }
      lst.push('end')
      this.buying = {
        csc: this.isCSCproduct ? this.buying.csc : null,
        toBeAsked: lst,
        ticketInfo: this.product,
        askPrice: this.product.ApisToCall.indexOf('price') > -1,
        pagecount: this.buying ? this.buying.pagecount : 0
      }
      this.goTo('/products/' + this.type + '/' + this.productId + '/' + this.articleId + '/' + this.buying.toBeAsked[0], false)
    }
  },
  beforeDestroy () {},
  mounted () {
    this.buying = {
      csc: this.buying ? this.buying.csc : null,
      pagecount: this.buying ? this.buying.pagecount : 0
    }
    this.product = null
    let p = { itemId: this.articleId, mediaType: 'Eticket' }
    if (this.isCSCproduct) {
      p.mediaType = 'TransportProduct'
      p.mediaSerialNumber = this.buying.csc.MediaSerialNumber
      p.mediaUnicity = this.buying.csc.MediaUnicity
    } else if (this.isCSC) {
      p.mediaType = 'Csc'
    }
    let promise = this._getSaleableItem(p)
    this.lastPromise = promise
    promise.then(data => {
      // console.log('data', data)
      this.product = data
    }).catch(e => {
      if (this.lastPromise == promise) {
        console.log(e)
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
          key: this.notifierKey,
          timeout: 3000
        })
        this.back()
      }
    })
  },
  watch: {}
}
</script>

<style></style>
